<template>
  <div>
    <!--EDITAR-->

    <ed-modal
      :title="formData.id == 0 ? 'Nova Função' : 'Editar Função'"
      :modal="showFormEdit"
      :loadingSave="config.loading.save"
      :isModal="false"
      :onSave="this.salvar"
      width="70%"
    >
      <div slot="modal-content" v-loading="config.loading.content">
        <ed-form
          :data="formData"
          :config="config"
          :response="response"
          :itens="formItems"
        >
          <div slot="form-footer"></div>
        </ed-form>
      </div>
    </ed-modal>

    <ed-table
      registerName="Inserir Nova Função"
      :onRegister="onRegister"
      :onEdit="onEdit"
      :onDelete="onDelete"
      :onSearch="getLtcatFuncao"
      :tableHead="tableHead"
      :tableData="tableData"
      :loadingTable="loadingTable"
      :pagination="pagination"
      :response="response"
    />
  </div>
</template>

<script>
import EdTable from "common/table";
import EdModal from "common/modal";
import EdForm from "common/form";
import Rest from "common/rest";
import Fct from "common/fct";
import FormItems from "./_form/ltcat-ghe-funcao-cadastrar";

export default {
  name: "ltcat.ghe.funcao",
  components: { EdTable, EdModal, EdForm },
  mixins: [Rest],
  props: {
    parent: {
      type: Object,
      default: null,
    },
    ltcat: {
      type: Object,
      default: null,
    },
  },
  computed: {
    event: {
      cache: false,
      get() {
        return this.$store.state.common.event;
      },
      set(value) {
        this.$store.dispatch("common/setEvent", value);
      },
    },
  },
  watch: {
    "parent.formData.id"() {
      this.getLtcatFuncao();
      this.getGhe();
    },
    "$store.state.ltcat.data.id"() {
      this.getGhe();
    },
    "formData.id_fun"() {
      this.config.disabled.cbo = this.formData.id_fun ? false : true;
      this.config.disabled.descricao = this.formData.id_fun ? false : true;

      var funcao = this.arrFindByField(
        this.config.list.id_fun,
        "id",
        this.formData.id_fun
      );

      if (funcao) {
        this.formData.cbo = funcao.cbo;
        this.formData.descricao = funcao.descricao;
      }
    },
  },
  data() {
    return {
      config: {
        click: {
          id_fun: this.getFuncao,
          replicar: this.getGhe,
        },
        loading: {
          save: false,
          content: false,
          id_fun: false,
          replicar: false,
        },
        list: {
          id_fun: [],
          replicar: [],
        },
        disabled: {
          cbo: true,
          descricao: true,
          id_fun: false,
        },
        title: {
          equipamentos_insert: "Inserir Equipamento",
          replicar_subs: "Sobrescrever medição caso existir",
        },
        description: {
          replicar_subs:
            "Se habilitar esse campo, o sistema vai excluir as medições existentes nos GHE selecionados e inserir novamente baseado nessa medição.",
        },
      },
      pagination: {},
      response: {},
      formData: {
        id: 0,
        id_ghe: this.parent.formData.id,
        id_fun: null,
        cbo: null,
        descricao: null,
        usuario: null,
        updated_at: null,
        replicar: [],
        replicar_subs: 0,
      },
      formItems: [],
      tableHead: [
        {
          key: "cbo",
          sortable: true,
          width: "80px",
          label: "CBO",
        },
        {
          key: "funcao",
          sortable: true,
          label: "Função",
        },
        {
          key: "descricao",
          sortable: true,
          show_colapse: true,
          label: "Descrição",
        },
        {
          key: "updated_at",
          width: "180px",
          sortable: true,
          show_user: true,
          label: "Atualização",
        },
      ],
      tableData: [],
      loadingTable: true,
      showFormEdit: false,
    };
  },
  beforeDestroy() {
    this.tableData = [];
  },
  created() {},

  mounted() {
    this.formItems = FormItems;
    this.getLtcatFuncao();
    this.getGhe();
  },

  methods: {
    onRegister: function () {
      this.formData = {
        id: 0,
        id_ghe: this.parent.formData.id,
        id_fun: null,
        cbo: null,
        descricao: null,
        usuario: null,
        updated_at: null,
        replicar: [],
        replicar_subs: 0,
      };
      this.config.disabled.id_fun = false;
      this.showFormEdit = !this.showFormEdit;
    },

    onEdit: function (data) {
      this.showFormEdit = !this.showFormEdit;
      this.config.loading.content = true;
      this.config.disabled.id_fun = true;
      this.config.list.id_fun = [];

      this.get(
        "ltcat/ghe/funcao/" + this.parent.formData.id + "/" + data.id
      ).then((result) => {
        result = result[0];
        this.response = result;
        this.config.loading.content = false;

        if (result.status == 200) {
          this.formData = {
            id: data.id,
            id_ghe: this.parent.formData.id,
            id_fun: data.funcao.id,
            cbo: data.cbo,
            descricao: data.descricao,
            usuario: data.usuario,
            updated_at: data.updated_at,
            replicar: [],
            replicar_subs: 0,
          };
          this.config.list.id_fun.push(data.funcao);
        }
      });
    },

    onDelete: function (data) {
      var self = this;

      this.$confirm(
        "O sistema vai excluir " +
          data.length +
          " registro(s). Deseja prosseguir?",
        "Atenção",
        {
          type: "warning",
        }
      ).then(() => {
        self.loadingEditAll = true;
        self.loadingTable = true;

        this.post("/ltcat/ghe/funcao/" + this.parent.formData.id + "/deletar", {
          ids: data,
        }).then((result) => {
          result = result[0];

          self.loadingEditAll = false;

          if (result.status == 200) {
            self.getLtcatFuncao();
            self.edMsg("Registo excluido com sucesso");
            self.event = new Date().getTime() + "-funcoes-save";
          }
        });
      });
    },

    getGhe: function (_search) {
      if (!this.$store.state.ltcat.data) return;

      this.config.loading.replicar = true;
      this.config.list.replicar = [];

      this.get("ltcat/ghe/" + this.$store.state.ltcat.data.id, {
        search: _search,
      }).then((result) => {
        result = result[0];
        this.config.loading.replicar = false;

        if (result.status == 200) {
          var data = result.data.data;

          for (let i = 0; i < data.length; i++) {
            const element = data[i];
            if (element.id != this.parent.formData.id) {
              this.config.list.replicar.push(element);
            }
          }
        }
      });
    },

    getFuncao: function (_search) {
      this.config.loading.id_fun = true;
      this.config.list.id_fun = [];

      this.get("funcao", { search: _search }).then((result) => {
        result = result[0];

        this.config.loading.id_fun = false;

        if (result.status == 200) {
          this.config.list.id_fun = result.data.data;
        }
      });
    },

    getLtcatFuncao(_search, _page, _pagination) {
      this.loadingTable = true;
      this.response = {};

      this.get("ltcat/ghe/funcao/" + this.parent.formData.id, {
        search: _search,
        page: _page,
        pagination: _pagination,
      }).then((result) => {
        result = result[0];
        this.response = result;
        this.loadingTable = false;

        if (result.status == 200) {
          var data = result.data.data,
            tableData = [],
            self = this,
            pagination = result.data;

          for (var i = 0; i < data.length; i++) {
            var item = {
              funcao: data[i].funcao.nome,
              cbo: data[i].cbo,
              descricao: data[i].descricao,
              updated_at: this.toDate(data[i].updated_at),
              _data: data[i],
              options: {
                disable_delete: !this.validarPermissao(567),
                disable_edit: !this.validarPermissao(567),
              },
              buttons: [],
            };
            tableData.push(item);
          }

          this.pagination = pagination;
          this.tableData = tableData;
        }
      });
    },

    salvar() {
      this.config.loading.save = true;
      this.response = {};

      this.post(
        "/ltcat/ghe/funcao/" + this.parent.formData.id + "/editar",
        this.formData
      ).then((result) => {
        result = result[0];

        this.config.loading.save = false;
        this.response = result;

        if (result.status == 200) {
          this.edMsg("Dados atualizados");
          this.showFormEdit = !this.showFormEdit;
          this.getLtcatFuncao();
          this.event = new Date().getTime() + "-funcoes-save";
        }
      });
    },
  },
};
</script>


// WEBPACK FOOTER //
// funcao.vue?2f6f42be